import React from 'react';
import { Alert, Button, Space } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useOfflineQueue } from '../../hooks/useOfflineQueue';
import { isOfflineCajaDevice } from '../../utils/serviceWorker';

/**
 * Aviso de lo que se hizo sin red y falta mandar al servidor.
 *
 * Va en la barra de toda la app, no escondido en Mesas: lo que no se sincronizó es dinero
 * que no está en el corte, y el dueño tiene que verlo sin ir a buscarlo. Lo rechazado
 * pesa más que lo pendiente, porque lo pendiente se arregla solo al volver el internet.
 */
const OfflineQueueNotice: React.FC = () => {
  const navigate = useNavigate();
  const { pending, failed, syncing } = useOfflineQueue();

  if (!isOfflineCajaDevice() || (pending.length === 0 && failed.length === 0)) return null;

  if (failed.length > 0) {
    return (
      <Alert
        type="error"
        showIcon
        banner
        style={{ marginBottom: 12 }}
        message={`${failed.length} operación(es) sin conexión que el servidor no aceptó`}
        description="Hay que revisarlas una por una: mientras tanto no están en las ventas ni en el corte."
        action={<Button size="small" danger onClick={() => navigate('/por-revisar')}>Revisar</Button>}
      />
    );
  }

  return (
    <Alert
      type="info"
      showIcon
      banner
      style={{ marginBottom: 12 }}
      message={syncing
        ? `Sincronizando ${pending.length} operación(es) hecha(s) sin conexión…`
        : `${pending.length} operación(es) sin conexión pendiente(s) de sincronizar`}
      description={syncing ? undefined : 'Se mandan solas en cuanto vuelva el internet.'}
      action={
        <Space>
          <Button size="small" onClick={() => navigate('/por-revisar')}>Ver</Button>
        </Space>
      }
    />
  );
};

export default OfflineQueueNotice;
